var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const AUTH_REASON_PARAM = 'authReason';
export const AUTH_SOURCE_PARAM = 'authSource';
export var AuthStatus;
(function (AuthStatus) {
    AuthStatus["AUTHENTICATE"] = "AUTHENTICATE";
    AuthStatus["REFRESH_TOKEN"] = "REFRESH_TOKEN";
})(AuthStatus || (AuthStatus = {}));
export var ParzivalGatewayAuthErrorType;
(function (ParzivalGatewayAuthErrorType) {
    ParzivalGatewayAuthErrorType[ParzivalGatewayAuthErrorType["MISSING_AUTH"] = 0] = "MISSING_AUTH";
    ParzivalGatewayAuthErrorType[ParzivalGatewayAuthErrorType["EXPIRED_AUTH"] = 1] = "EXPIRED_AUTH";
    ParzivalGatewayAuthErrorType[ParzivalGatewayAuthErrorType["INCORRECT_AUTH"] = 2] = "INCORRECT_AUTH";
})(ParzivalGatewayAuthErrorType || (ParzivalGatewayAuthErrorType = {}));
export class ParzivalGatewayAuthError extends Error {
    constructor(message, errorType, status) {
        super(message);
        this.name = 'ParzivalGatewayAuthError';
        this.errorType = errorType;
        this.originalMessage = message;
        this.status = status;
    }
}
export const handleParzivalGatewayError = (response) => __awaiter(void 0, void 0, void 0, function* () {
    // Only handle auth-related error codes
    if (response.status !== 400 && response.status !== 401) {
        return;
    }
    const errorBody = yield response.json();
    const { message } = errorBody;
    let errorType = ParzivalGatewayAuthErrorType.INCORRECT_AUTH;
    // Check status code first - 400 errors are MISSING_AUTH
    if (response.status === 400) {
        errorType = ParzivalGatewayAuthErrorType.MISSING_AUTH;
    }
    else if (message.includes(AuthStatus.REFRESH_TOKEN)) {
        errorType = ParzivalGatewayAuthErrorType.EXPIRED_AUTH;
    }
    else if (message.includes('Unauthorized')) {
        errorType = ParzivalGatewayAuthErrorType.INCORRECT_AUTH;
    }
    throw new ParzivalGatewayAuthError(`Authentication failed: ${message}`, errorType, response.status);
});
